






















































import * as R from 'ramda';
import Vue from 'vue';

export interface DesProduct {
  id: string;
  name?: string;
  photo?: {
    small: string;
  };
}

export default Vue.extend({
  props: {
    country: {
      type: String as () => string,
      default: 'MY',
    },
    initialId: String as () => string | null,
    value: Object as () => DesProduct | null,
  },

  created() {
    // @ts-ignore
    this.timeoutId = undefined;
  },

  data() {
    return {
      loading: false,
      product: null as DesProduct | null,
      query: '',
      searchResult: [] as DesProduct[],
    };
  },

  mounted() {
    if (this.initialId) {
      this.fetchDesProduct(this.initialId);
    }
  },

  watch: {
    initialId(newVal: string | null, oldVal: string | null) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.fetchDesProduct(newVal);
        } else {
          this.product = null;
          this.query = '';
          this.searchResult = [];
        }
      }
    },
    value(newVal: DesProduct | null) {
      if (newVal === null) {
        this.product = null;
        this.query = '';
        this.searchResult = [];
      }
    },
  },

  methods: {
    handleSearch(query: string) {
      if (query.length < 3) {
        return;
      }

      // @ts-ignore
      if (this.timeoutId) {
        // @ts-ignore
        clearTimeout(this.timeoutId);
      }

      const { country } = this;

      // @ts-ignore
      this.timeoutId = setTimeout(() => {
        this.searchDesProduct(country, query);
      }, 500);
    },

    handleSelect(val: string, option: any) {
      const selected = R.find(R.propEq('id', val), this.searchResult);

      this.product = selected || null;

      this.$emit('change', selected);
      this.$emit('input', selected);
    },

    async fetchDesProduct(id: string) {
      this.loading = true;
      try {
        const res = await fetch('https://api.mailertrack.com/graphql', {
          method: 'post',
          headers: {
            'Content-type': 'application/json',
            'x-api-key': '312c0b69f50bd65fce9bdbe64780fcab',
          },
          mode: 'cors',
          body: JSON.stringify({
            query: `query ($id: Int!) {
              product(id: $id) {
                id
                name
                photo {
                  small
                }
              }
            }`,
            variables: { id },
          }),
        });

        const result = await res.json();

        this.product = {
          ...result.data.product,
          id: result.data.product.id.toString(),
        };
      } catch (err) {
        console.error(err); // tslint:disable-line no-console
        this.$message.error('Unable to load DES product.');
      } finally {
        this.loading = false;
      }
    },

    async searchDesProduct(country: string, query: string) {
      this.loading = true;
      try {
        const res = await fetch('https://api.mailertrack.com/graphql', {
          method: 'post',
          headers: {
            'Content-type': 'application/json',
            'x-api-key': '312c0b69f50bd65fce9bdbe64780fcab',
          },
          mode: 'cors',
          body: JSON.stringify({
            query: `query ($country: String!, $query: String!) {
            generalSearch(country: $country, limit: 100, query: $query, searchAll: true) {
              id
              name
              photo {
                small
              }
            }
          }`,
            variables: { country: country.toUpperCase(), query },
          }),
        });

        const result = await res.json();

        this.searchResult = R.map(
          (p: DesProduct) => ({
            ...p,
            id: p.id.toString(),
          }),
          result.data.generalSearch,
        );
      } catch (err) {
        console.error(err); // tslint:disable-line no-console
        this.$message.error('Unable to search DES product.');
      } finally {
        this.loading = false;
      }
    },
  },
});
